import { ReconciliationReportSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * Sprint 100 — Daily payment reconciliation reports.
 *
 *   platformBrands/{brandId}/reconciliationReports/{YYYY-MM-DD}
 *
 * Written by the `reconcilePaymentsDaily` scheduled function (and the
 * `reconcilePaymentsManual` super-admin callable). Read access scoped to
 * super-admin of THIS brand per `infra/firestore.rules` (Sprint 100).
 */
export function reconciliationReportsRepoFor(brandId: string) {
  return createRepo({
    path: `platformBrands/${brandId}/reconciliationReports`,
    schema: ReconciliationReportSchema,
    name: `platformBrands/${brandId}/reconciliationReports`,
  });
}
